export default "__VITE_ASSET__BZbdnHwh__"